/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_TitleInputs */

const en_wc_dl_title = /** @type {(inputs: Wc_Dl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft download`)
};

/**
* | output |
* | --- |
* | "WordCraft download" |
*
* @param {Wc_Dl_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_title = /** @type {((inputs?: Wc_Dl_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_title(inputs)
});
export { wc_dl_title as "wc.dl.title" }